(function ($) {
  Drupal.behaviors.mantleformOptionsFormatterV1 = {
    attach: function (context, settings) {
      var $options_formatters = $('.js-form-options-formatter', context);

      $options_formatters.each(function (i, obj) {
        var $formatter = $(obj);
        var field_name = $formatter.data('field-name');
        var $items = $('.form-options-formatter__item', $formatter);

        // each form-options-formatter__item corresponding quiz option data.
        $items.on('click', function (e) {
          var $item = $(this);
          var $field = $('[data-field-value]', $item);
          var field_value = $field.data('field-value');

          // trigger a syncethic choice.
          $item.trigger('syn_choice', [field_value]);
        });
      });
    }
  };
})(jQuery);
